import { SocialIcon, SocialLink, SocialMediaLinks } from "./SocialLogos.styles";

const SocialLogos = () => {
  const ORG_INSTA_LINK = "https://www.instagram.com/makemytrip/";
  const ORG_X_LINK = "https://x.com/makemytrip";
  const ORG_LI_LINK =
    "https://in.linkedin.com/company/makemytrip.com?open=outside";
  const ORG_FB_LINK = "https://www.facebook.com/makemytrip/";

  return (
    <SocialMediaLinks>
      {ORG_INSTA_LINK && (
        <SocialLink href={ORG_INSTA_LINK}>
          <SocialIcon className="instagramIcon landingSprite2" />
        </SocialLink>
      )}
      {ORG_X_LINK && (
        <SocialLink href={ORG_X_LINK}>
          <SocialIcon className="twiiterIcon landingSprite2" />
        </SocialLink>
      )}
      {ORG_LI_LINK && (
        <SocialLink href={ORG_LI_LINK}>
          <SocialIcon className="linkedinIcon landingSprite2" />
        </SocialLink>
      )}
      {ORG_FB_LINK && (
        <SocialLink href={ORG_FB_LINK}>
          <SocialIcon className="facebookIcon landingSprite2" />
        </SocialLink>
      )}
    </SocialMediaLinks>
  );
};

export default SocialLogos;
